module.exports = __webpack_public_path__ + "media/images/course/certificado-2f6e4f2b42dd510221c522873f0e2894.png";